import { cfetch } from '@confluence/network';

import type { AudioRequest, AudioBriefingRequest } from '../types/audioRequestType';

export const AUDIO_SUMMARY_API_ROOT = '/gateway/api/v1/audio/summary';
export const AUDIO_NARRATION_API_ROOT = '/gateway/api/v1/audio/narration';
export const AUDIO_BRIEFING_API_ROOT = '/gateway/api/v1/audio/briefing';

export const getSpeech = async ({
	pageAri,
	locale,
	activationId,
}: AudioRequest): Promise<ReadableStream<Uint8Array>> => {
	const response = await cfetch(AUDIO_SUMMARY_API_ROOT, {
		method: 'POST',
		body: JSON.stringify({
			resource_ari: pageAri,
			locale,
		}),
		headers: {
			'Content-Type': 'application/json',
			'ATL-ActivationId': activationId,
		},
	});

	if (!response.body) {
		throw new Error('Response body is null');
	}

	return response.body;
};

export const getNarration = async ({
	pageAri,
	locale,
	activationId,
}: AudioRequest): Promise<ReadableStream<Uint8Array>> => {
	const response = await cfetch(AUDIO_NARRATION_API_ROOT, {
		method: 'POST',
		body: JSON.stringify({
			resource_ari: pageAri,
			locale,
			transcriber_model: 'TEXT_ONLY',
		}),
		headers: {
			'Content-Type': 'application/json',
			'ATL-ActivationId': activationId,
		},
	});

	if (!response.body) {
		throw new Error('Response body is null');
	}

	return response.body;
};

export const getBriefing = async ({
	activeContentAri,
	additionalResources,
	locale,
	activationId,
	customization,
}: AudioBriefingRequest): Promise<ReadableStream<Uint8Array>> => {
	const additionalResourcesBody = additionalResources.map((resource) => ({
		resource_ari: resource.ari,
		activation_id: activationId,
	}));

	const response = await cfetch(AUDIO_BRIEFING_API_ROOT, {
		method: 'POST',
		body: JSON.stringify({
			resources: [
				{
					resource_ari: activeContentAri,
					activation_id: activationId,
				},
				...additionalResourcesBody,
			],
			locale,
			user_instruction: customization,
		}),
		headers: {
			'Content-Type': 'application/json',
			'ATL-ActivationId': activationId,
		},
	});

	if (!response.body) {
		throw new Error('Response body is null');
	}

	return response.body;
};
